import {Component} from '@angular/core';
import {
	EntitySelectComponent,
	BaseModel,
	BaseModelInterface,
} from '@app/abstracts';
import {ErrorService} from '@app/services';
import {CategorySearchParams} from '../category-search-params';
import {CategoryService} from '../category.service';
import {Category} from '../category';
import { QuickFormService } from '../../../plugins/quick-form';
@Component({
  selector: 'hpf-category-select',
  templateUrl: '../../../abstracts/entity-select/entity-select.component.html'
})
export class CategorySelectComponent extends EntitySelectComponent< Category> {
  protected modelName = 'category';
  /**
   * Constructor
   * @param {CategoryService} categoryService
   * @param {ErrorService} errorService
   */
  constructor(private categoryService: CategoryService,
              protected errorService: ErrorService,
              protected quickFormService: QuickFormService) {
    super(errorService, quickFormService);
  }
  ngOnInit() {
		super.ngOnInit();
    // Refresh model in case of creation by quick form
		this.subscriptions.push(
			this.quickFormService.refresh.subscribe(
				(model: BaseModel<BaseModelInterface, {}>) => {
					if(!(model instanceof Category)) return;
          if(this.multiple) {
            if (!this.model) this.model = [];
            (<Category[]>this.model).push(<Category>model);
          } else {
            this.model = <Category>model;
          }
          this.refresh();
				}
			)
		);
	}
  /** @inheritDoc */
  protected async getList(): Promise< Category[]> {
      const params = new CategorySearchParams({
          _limit: this.resultsLimit,
          _page: this.currentPage
      });
      if (this.filterEnabled && this.filterValue) {
        params.props._text = this.filterValue;
      }
      return (await this.categoryService.list(params.toObject())).items;
  }
  /** @inheritDoc */
  protected async getOne(id: string): Promise< Category> {
      return await this.categoryService.get(id);
  }
}
